"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const uris_1 = require("../../globals/uris");
const autocontrol_1 = require("../autocontrol");
/**
 * A control based on brownian motion
 */
class BrownianControl extends autocontrol_1.AutoControl {
    constructor(uri, store, initialValue) {
        super(uri, uris_1.BROWNIAN, store);
        //init values and parameters
        if (!initialValue) {
            initialValue = 0.5;
        }
        this.min = 0;
        this.max = 1;
        this.updateValue(initialValue);
    }
    init() {
        const _super = name => super[name];
        return __awaiter(this, void 0, void 0, function* () {
            yield _super("init").call(this);
            const stepSizeUri = yield this.store.setControlParam(this.uri, uris_1.BROWNIAN_MAX_STEP_SIZE, 0.1);
            this.store.addValueObserver(stepSizeUri, uris_1.VALUE, this);
            const triggUri = yield this.store.setControlParam(this.uri, uris_1.AUTO_CONTROL_TRIGGER, 1);
            this.store.addValueObserver(triggUri, uris_1.VALUE, this);
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            var currentMaxStepSize = Number(yield this.store.findControlParamValue(this.uri, uris_1.BROWNIAN_MAX_STEP_SIZE));
            var currentStep = (2 * currentMaxStepSize * Math.random()) - currentMaxStepSize;
            var newValue = this.getValue() + currentStep;
            newValue = Math.min(Math.max(newValue, this.min), this.max);
            this.updateValue(newValue);
        });
    }
}
exports.BrownianControl = BrownianControl;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/controls/auto/browniancontrol.js
// module id = 1291
// module chunks = 3